module.exports = __webpack_public_path__ + "img/9.fe69e758.jpg";